import { alpha, type Theme } from "@mui/material/styles";

/** Matches MUI Alert `severity="warning"` standard background. */
export function pendingApprovalBackground(theme: Theme): string {
  return alpha(theme.palette.warning.main, theme.palette.mode === "light" ? 0.12 : 0.15);
}

export const pendingApprovalBackgroundSx = {
  bgcolor: pendingApprovalBackground,
} as const;

/** Button styling: warning banner background with success label text. */
export const pendingApprovalButtonSx = {
  ...pendingApprovalBackgroundSx,
  "&:hover": {
    bgcolor: (theme: Theme) => alpha(theme.palette.warning.main, theme.palette.mode === "light" ? 0.2 : 0.25),
    borderColor: "warning.dark",
    color: "success.dark",
  },
  borderColor: "warning.main",
  color: "success.main",
} as const;
